<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.FlightInformationManagement')"
    width="350px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="shipping-schedule-form-dialog details-view"
  >
    <div class="main-content">
      <div style="width:fit-content;margin-left: 10px;">
        <el-button type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="margin: 10px">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item required :label="$t('Pricing.FlightNo')">
                <el-input
                  v-model="ss.flightNo"
                  no="flightNo"
                />
              </el-form-item>
              <!-- 起运港 -->
              <el-form-item :label="$t('Pricing.POL')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="ss.pol"
                  @parentCallBack="p=>{ss.pol=p.value}"
                />
              </el-form-item>
              <!-- 目的港 -->
              <el-form-item :label="$t('Pricing.POD')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="ss.pod"
                  @parentCallBack="p=>{ss.pod=p.value}"
                />
              </el-form-item>

              <el-form-item :label="$t('Pricing.ClosingTime')">
                <div style="display: flex">
                  <el-time-picker
                    v-model="ss.closingTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    clearable
                  />
                  <el-tooltip style="align-items: center;display: flex;margin-left:5px;" effect="dark" :content="$t('Pricing.emptyTime')" placement="right-start">
                    <i class="el-icon-warning" style="font-size:20px;" />
                  </el-tooltip>
                </div>
              </el-form-item>

              <el-form-item :label="$t('Pricing.DepartureTime')">
                <div style="display: flex">
                  <el-time-picker
                    v-model="ss.departureTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    clearable
                  />
                  <el-tooltip style="align-items: center;display: flex;margin-left:5px;" effect="dark" :content="$t('Pricing.emptyTime')" placement="right-start">
                    <i class="el-icon-warning" style="font-size:20px;" />
                  </el-tooltip>
                </div>
              </el-form-item>

              <el-form-item :label="$t('Pricing.ArrivalTime')">
                <div style="display: flex;">
                  <el-select v-model="ss.days" :placeholder="$t('Pricing.PlsSelect')" style="width:110px;">
                    <el-option :value="0" label="+0" />
                    <el-option :value="1" label="+1" />
                    <el-option :value="2" label="+2" />
                    <el-option :value="3" label="+3" />
                  </el-select>
                  <el-time-picker
                    v-model="ss.arrivalTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    clearable
                  />
                  <el-tooltip style="align-items: center;display: flex;margin-left:5px;" effect="dark" :content="$t('Pricing.emptyTime')" placement="right-start">
                    <i class="el-icon-warning" style="font-size:20px;" />
                  </el-tooltip>
                </div>
              </el-form-item>

              <el-form-item :label="$t('Pricing.Aircraft')">
                <el-input
                  v-model="ss.aircraft"
                />
              </el-form-item>

              <el-form-item :label="$t('Pricing.SizeLimit')">
                <el-input
                  v-model="ss.sizeLimit"
                />
              </el-form-item>

              <el-form-item :label="$t('Pricing.SingletonWeightLimit')">
                <el-input
                  v-model="ss.singletonWeightLimit"
                />
              </el-form-item>

              <el-form-item :label="$t('Pricing.ChemicalPkggReq')">
                <el-input
                  v-model="ss.chemicalPkggReq"
                />
              </el-form-item>

              <el-form-item :label="$t('Pricing.LithiumBatteryReq')">
                <el-input
                  v-model="ss.lithiumBatteryReq"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { saveAirFlightInfo } from '@/api/price/airFlightInfo'

export default {
  name: 'ShippingScheduleForm',
  components: {
    CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    ss: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      selectTypeNames: TYPE_NAMES
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.selectRow = null
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  methods: {
    onSubmit() {
      this.fullscreenLoading = getLoading()
      if (!this.ss.flightNo) {
        this.$message.warning(this.$t('Pricing.flightNumber'))
        this.fullscreenLoading.close()
        return
      }
      // NEWB2B-4750 天数不等于0，不必判断到达时间-起飞时间
      if (this.ss.days === 0 && this.ss.departureTime > this.ss.arrivalTime) {
        this.$message.warning(this.$t('Pricing.TimeWarning'))
        this.fullscreenLoading.close()
        return
      }
      this.ss.branchId = this.$store.getters.currentOfficeId
      saveAirFlightInfo(this.ss).then((_res) => {
        this.fullscreenLoading.close()
        this.$message.success(this.$t('Pricing.SavedSucceed'))
        this.$emit('close')
        this.$emit('reload')
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.shipping-schedule-form-dialog{
  .form-flex{
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  textarea.el-textarea__inner{
    min-height: 80px !important;
  }
}
</style>
